import { render, staticRenderFns } from "./DocMasterViewAdvisor.vue?vue&type=template&id=041ac301&scoped=true&"
import script from "./DocMasterViewAdvisor.vue?vue&type=script&lang=js&"
export * from "./DocMasterViewAdvisor.vue?vue&type=script&lang=js&"
import style0 from "./DocMasterViewAdvisor.vue?vue&type=style&index=0&id=041ac301&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041ac301",
  null
  
)

export default component.exports